<template>
  <div> 
    <el-table style="margin-top:10px;" height="35rem" :data="list" border v-loading='meta.loading'>
      <!-- <el-table-column align="center" width="50" type="index" label="全选">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="操作" width="100px;">
          <template slot-scope="{row}">            
              <el-button v-if="!row.disabled" @click.native="refund(row)" icon="el-icon-close" size="mini" circle type="danger" title="退费"></el-button>            
              <el-tag v-else type="danger">已退费</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="项目名称" align="center" prop="name" width="200px">
          <template slot-scope="{ row }">            
            <div>
              {{ row.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="类别" align="center" prop="rpClass" width="80px"></el-table-column>
        <el-table-column label="规格" align="center" prop="standard" width="200px"> </el-table-column>
        <el-table-column label="单价（元）" align="center" prop="price" width="100px"> </el-table-column>
        <el-table-column label="数量" align="center" prop="quantity" width="120px">
          <template slot-scope="{ row }"> 
            <div>{{ row.quantity }}</div>
          </template>
        </el-table-column>
        <el-table-column label="总金额（元）" align="center" prop="" width="140px">
          <template slot-scope="{ row }">
            {{ row.price? row.price * row.quantity : '' }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="可退数量" align="center" prop="quantity" width="120px">
          <template slot-scope="{ row }"> 
            <div>{{ row.quantity }}</div>
          </template>
        </el-table-column>
        <el-table-column label="实际退费数量" align="center" prop="quantity" width="120px">
          <template slot-scope="{ row }"> 
            <el-input class="" v-model="row.quantity" maxlength="500" placeholder="请输入" size="small" clearable></el-input>            
          </template>
        </el-table-column> -->
        <el-table-column label="医保范围" align="center" prop="claimType" width="110px">
          <template slot-scope="{ row }">
            <div>{{ row.claimType }}</div>
          </template>
        </el-table-column>
        <el-table-column label="开单人" align="center" prop="doctorName"> </el-table-column>
        <el-table-column label="执行科室" align="center" prop="execDeptCode" width="130px">
          <template slot-scope="{ row }">
            <div>
              {{ row.execDeptCode | dictText("Dept") }}
            </div>            
          </template>
        </el-table-column>
        <el-table-column label="开单时间" align="center" prop="" width="210px">
          <template slot-scope="{ row }">
            <div>{{ row.adviceTime | fmtDate }}</div>
          </template>
        </el-table-column>
    </el-table>
    <div slot="footer">
      <el-row style="margin-top: 20px; text-align: right">
        <el-button type="info" size="large" @click.native="$emit('close')" style="margin-right: 1rem">关闭</el-button>
      </el-row>
    </div>
    </div>
  </template>
  
  <script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    components: {
    },
    props: {
      visible: Boolean,
      infoDetail:Object
    },
    data() {
      return {
        selIndex:0,
        meta:{
          loading:false,
          showBed:false
        },
        condition:{},
        list:[],
        feeItems:[]
      };
    },
    computed: {
      ...mapGetters(["dict", , "Enum", "dictEnum","user"])
    },
    filters:{
    },
    watch:{
      infoDetail(val){
        if(val.id) this.open()
      }
    },
    mounted() {
    
    },
    methods: {
      open(){ 
        this.condition.ipNo = this.infoDetail.ipNo
        this.query() 
      },
  
      close() {
        this.$emit("update:visible", false);
      },      
      query() {       
        this.meta.loading = true;
        api.Billing.query(this.condition)
          .then((res) => {
            this.list = res.items;
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },     
      save(row){
        let data = row || this.list[this.list.length-1]
        if(!data.name) return this.$message.error('请选择收费项目')
        if(!data.quantity) return this.$message.error('请输入数量')        
        this.meta.loading = true;
        api.Billing.save(data)
          .then((res) => {
            this.$message.success('保存成功');
            this.query();
            // this.clear();
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      refund(row){
        this.$prompt(
                '请输入退费原因：', 
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type:"warning",            // 图标样式 "warning"|"error"...
                    inputValue: '',
                    inputErrorMessage: '输入不能为空',
                    inputValidator: (value) => {       // 点击按钮时，对文本框里面的值进行验证
                        if(!value) {
                            return '输入不能为空';
                        }
                    }
                }).then(({value}) => {
                  this.meta.loading = true;
                  this.$set(row,'disabled',true)
                  this.$set(row,'refundNurseCode',this.user.id)
                  this.$set(row,'refundNurseName',this.user.name)
                  this.$set(row,'refundTime',this.$utils.Dt.now())
                  this.$set(row,'refundReason',value)
                  api.Billing.save(row)
                    .then((res) => {
                      this.meta.loading = false;
                      this.$message.success("退费成功");
                      this.query();
                    })
                    .catch((err) => {
                      self.meta.loading = false;
                      self.$message.error(err);
                    });
                }).catch((err) => {
                    console.log(err);
                });  
      }
    },
  };
  </script>